export enum AlertType {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning"
}

export type AlertButtons = {label: string}[];

export interface AlertArguments {
  message: string;
  buttons?: AlertButtons;
  alertType?: AlertType;
  response?: { data: { [key: string]: unknown; message?: string } };
}

export const GENERATE_ALERT = "GENERATE_ALERT";
export interface GenerateAlertAction {
  type: typeof GENERATE_ALERT;
  alertType: AlertType;
  message: unknown;
  buttons: {label: string}[];
}

export const DISMISS_ALERT = "DISMISS_ALERT";
export interface DismissAlertAction {
  type: typeof DISMISS_ALERT;
}

export type AlertAction = (
  GenerateAlertAction |
  DismissAlertAction
)
